export default "__VITE_ASSET__sS8Sn9ip__"